import moment from 'moment';
import 'moment/locale/tr';

const renderApplicationDate = (date: string) => {
  return moment(new Date(date)).locale('de').format('DD MMMM YYYY');
};

export default renderApplicationDate;
